import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaRegQuestionCircle } from "react-icons/fa";
import "../assets/style/product/product-card.scss";
import Switch from "@material-ui/core/Switch";
import { toast } from "react-toastify";
import { apiJson } from "../api/Api";
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { set_categories } from "../redux/actions/CategoriesAction";
import { set_brands } from "../redux/actions/BrandsAction";
import VariantCard from "./VariantCard";
import ClipLoader from "react-spinners/ClipLoader";
import "react-quill/dist/quill.snow.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { set_variants } from "../redux/actions/ProductsAction";
import RSelect from "react-select";
import { getClass } from "../utils/utils";
import { WithContext as ReactTags } from "react-tag-input";
import { Box, Button, FormControlLabel } from "@material-ui/core";
import { MdOutlineSave } from "react-icons/md";

const suggestions = [];

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

const productUnitOptions = [
  { value: null, label: "None" },
  { value: "piece", label: "Piece" },
  { value: "carton", label: "Carton" },
  { value: "sqm", label: "Sqm" },
  { value: "weight", label: "Weight" },
];

function ProductCard(props) {
  const { state, id } = useParams();

  const [loading, setLoading] = useState(false);
  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [video, setVideo] = useState("");
  const [descriptionEn, setDescriptionEn] = useState("");
  const [descriptionAr, setDescriptionAr] = useState("");
  const [benefitsEn, setBenefitsEn] = useState("");
  const [benefitsAr, setBenefitsAr] = useState("");
  const [featuresEn, setFeaturesEn] = useState("");
  const [featuresAr, setFeaturesAr] = useState("");
  const [howToEn, setHowToEn] = useState("");
  const [howToAr, setHowToAr] = useState("");
  const [lead_days, setLeadDays] = useState("");
  const [country_of_origin, setCountryOfOrigin] = useState("");
  const [selectedCat, setSelectedCat] = useState([]);
  const [selectedShipmentRule, setSelectedShipmentRule] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState({});
  const [selectedUnit, setSelectedUnit] = useState({});
  const [isTool, setIsTool] = useState(false);
  const [isWholesale, setIsWholesale] = useState(false);
  const [isInquiry, setIsInquiry] = useState(false);
  const [isBulkOrder, setIsBulkOrder] = useState(false);
  const [pickupAllowed, setPickupAllowed] = useState(false);
  const [tags, setTags] = useState([]);

  const [show, setShow] = useState(state === "view");
  const [errorMessage, setErrorMessage] = useState(false);
  const [generalMessage, setGeneralMessage] = useState(false);
  const [selectedVar, setSelectedVar] = useState(-1);
  const [submitForm, setSubmitForm] = useState(false);

  const [shipmentRulesList, setShipmentRulesList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [brandsList, setBrandsList] = useState([]);

  const [relatedProducts, setRelatedProducts] = useState([]);
  const [relatedTools, setRelatedTools] = useState([]);
  const [relatedServices, setRelatedServices] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedService, setSelectedService] = useState([]);
  const [selectedTool, setSelectedTool] = useState([]);

  // ─── Sync all fields when product or id changes ───────────────────────────
  useEffect(() => {
    setShow(state === "view");
    setErrorMessage(false);
    setGeneralMessage(false);

    if (id === "create") {
      setNameEn("");
      setNameAr("");
      setVideo("");
      setDescriptionEn("");
      setDescriptionAr("");
      setBenefitsEn("");
      setBenefitsAr("");
      setFeaturesEn("");
      setFeaturesAr("");
      setHowToEn("");
      setHowToAr("");
      setLeadDays("");
      setCountryOfOrigin("");
      setSelectedCat([]);
      setSelectedShipmentRule(null);
      setSelectedBrand({});
      setSelectedUnit({});
      setIsTool(false);
      setIsWholesale(false);
      setIsInquiry(false);
      setIsBulkOrder(false);
      setPickupAllowed(false);
      setTags([]);
      setSelectedProduct([]);
      setSelectedService([]);
      setSelectedTool([]);
    } else if (props.product && Object.keys(props.product).length > 0) {
      setNameEn(props.product.name_en || "");
      setNameAr(props.product.name_ar || "");
      setVideo(props.product.video || "");
      setDescriptionEn(props.product.description_en || "");
      setDescriptionAr(props.product.description_ar || "");
      setBenefitsEn(props.product.benefits_en || "");
      setBenefitsAr(props.product.benefits_ar || "");
      setFeaturesEn(props.product.features_en || "");
      setFeaturesAr(props.product.features_ar || "");
      setHowToEn(props.product.how_to_use_en || "");
      setHowToAr(props.product.how_to_use_ar || "");
      setLeadDays(props.product.lead_days || "");
      setCountryOfOrigin(props.product.country_of_origin || "");
      setSelectedBrand({
        value: props.product.brand_id,
        label: props.product.brand_name_en,
      });
      setSelectedUnit({
        value: props.product.unit,
        label: props.product.unit,
      });
      setSelectedShipmentRule(
        props.product.shipment_rule_id
          ? {
              value: props.product.shipment_rule_id,
              label: props.product.shipment_rule_name,
            }
          : null,
      );
      setSelectedCat(
        props.product.categories?.map((cat) => ({
          value: cat.id,
          label: cat.title_en,
        })) || [],
      );
      setIsTool(props.product.tool ?? false);
      setIsWholesale(props.product.product_type === "wholesale");
      setIsInquiry(props.product.is_inquiry ?? false);
      setIsBulkOrder(props.product.is_bulk_order ?? false);
      setPickupAllowed(props.product.pickup_allowed ?? false);
      setTags(
        props.product.keywords?.map((tag) => ({
          id: tag.name,
          text: tag.name,
        })) || [],
      );
      setSelectedService(
        props.product.related_services?.map((item) => ({
          value: item.id,
          label: item.name_en,
        })) || [],
      );
      setSelectedProduct(
        props.product.related_products?.map((item) => ({
          value: item.id,
          label: item.name_en,
        })) || [],
      );
      setSelectedTool(
        props.product.related_tools?.map((item) => ({
          value: item.id,
          label: item.name_en,
        })) || [],
      );
    }
    // eslint-disable-next-line
  }, [id, props.product?.id, state]);

  // ─── Fetch related services once ─────────────────────────────────────────
  useEffect(() => {
    apiJson.services.getRelatedServices().then((res) => {
      if (res.success) {
        setRelatedServices(
          res.data.map((item) => ({ value: item.id, label: item.name_en })),
        );
      }
    });
  }, []);

  // ─── Fetch brands, shipment rules, categories when store changes ──────────
  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const handleApiError = (response) => {
    message =
      response.message && response.message !== ""
        ? response.message
        : response.errors || "something went wrong";
    showError();
  };

  const fetchBrands = () => {
    apiJson.brands.getBrands().then((response) => {
      if (response.success) {
        props.set_brands({ brands: response.data });
        setBrandsList(
          response.data.map((item) => ({
            value: item.id,
            label: item.name_en,
          })),
        );
      } else {
        handleApiError(response);
      }
    });
  };

  useEffect(() => {
    fetchBrands();

    apiJson.shipmentRules.getShipmentRules().then((response) => {
      if (response.success) {
        setShipmentRulesList(
          response.data.map((item) => ({
            value: item.id,
            label:
              item.name === "shipment_rule_1"
                ? "Free Shipping Over 99"
                : item.name === "shipment_rule_2"
                  ? "Free Shipping Over 3000 (Tiered Charges)"
                  : item.name === "shipment_rule_3"
                    ? "Shipping Included in Price"
                    : "Weight-Based Shipping",
          })),
        );
      } else {
        handleApiError(response);
      }
    });

    apiJson.categories.getCategorieForProductServices().then((response) => {
      if (response.success) {
        const filtered = response.data.filter(
          (cat) => cat.country_name_en === props.store.country_name_en,
        );
        props.set_categories({ categories: filtered });
        setCategoriesList(
          filtered.map((item) => ({ value: item.id, label: item.title_en })),
        );
      } else {
        handleApiError(response);
      }
    });
    // eslint-disable-next-line
  }, [props.store]);

  // ─── Scroll to first error after submit ───────────────────────────────────
  useEffect(() => {
    if (document.getElementsByClassName("error").length > 0 && submitForm) {
      setSubmitForm(false);
      document.getElementsByClassName("error")[0].scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
    // eslint-disable-next-line
  }, [submitForm]);

  // ─── Tags handlers ────────────────────────────────────────────────────────
  const handleDelete = (i) => setTags(tags.filter((_, index) => index !== i));
  const handleAddition = (tag) => setTags([...tags, tag]);
  const handleDrag = (tag, currPos, newPos) => {
    const newTags = [...tags];
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setTags(newTags);
  };
  const handleTagClick = (index) => {
    console.log("The tag at index " + index + " was clicked");
  };

  // ─── Debounced related product/tool search ────────────────────────────────
  let timeoutId;

  const handleRelatedProductsInputChange = (inputValue) => {
    clearTimeout(timeoutId);
    if (!inputValue) {
      setRelatedProducts([]);
      return;
    }
    setLoading(true);
    timeoutId = setTimeout(() => {
      apiJson.products
        .getRelatedProducts(inputValue)
        .then((res) => {
          if (res.success) {
            setRelatedProducts(
              res.data.map((item) => ({ value: item.id, label: item.name_en })),
            );
          }
          setLoading(false);
        })
        .finally(() => setLoading(false));
    }, 1000);
  };

  const handleRelatedToolsInputChange = (inputValue) => {
    clearTimeout(timeoutId);
    if (!inputValue) {
      setRelatedTools([]);
      return;
    }
    setLoading(true);
    timeoutId = setTimeout(() => {
      apiJson.products
        .getRelatedTools(inputValue)
        .then((res) => {
          if (res.success) {
            setRelatedTools(
              res.data.map((item) => ({ value: item.id, label: item.name_en })),
            );
          }
          setLoading(false);
        })
        .finally(() => setLoading(false));
    }, 1000);
  };

  // ─── Related product/service builders ────────────────────────────────────
  const mergeArrays = () => [
    ...(selectedProduct?.map((item) => ({
      related_product_id: parseInt(item.value),
    })) || []),
    ...(selectedTool?.map((item) => ({
      related_product_id: parseInt(item.value),
    })) || []),
  ];

  const convertToServiceList = () =>
    selectedService?.map((item) => ({
      related_service_id: parseInt(item.value),
    })) || [];

  // ─── Shared keywords builder ──────────────────────────────────────────────
  const buildKeywords = () => tags.map((tag) => ({ name: tag.text }));

  // ─── Shared validation ────────────────────────────────────────────────────
  const validateVariants = () => {
    let hasErrors = false;

    const updatedVariants = props.variants.map((variant) => {
      if (variant._destroy) return variant;

      const isInvalid =
        !variant.name_en?.trim() ||
        (variant.description_en != null && !variant.description_en?.trim()) ||
        (variant.benefits_en != null && !variant.benefits_en?.trim()) ||
        (variant.features_en != null && !variant.features_en?.trim()) ||
        (variant.how_to_use_en != null && !variant.how_to_use_en?.trim()) ||
        (variant.quantity != null && !variant.quantity?.toString().trim()) ||
        !variant.variation?.trim() ||
        (variant.price != null && !variant.price?.toString().trim()) ||
        (variant.sku != null && !variant.sku?.toString().trim()) ||
        (variant.weight != null && !variant.weight?.toString().trim()) ||
        (variant.enable_3d_image && !variant.android_3d_image) ||
        !variant.featured_image?.trim();

      if (isInvalid) {
        hasErrors = true;
        return { ...variant, showError: true };
      }
      return { ...variant, showError: false };
    });

    props.set_variants(updatedVariants);
    return hasErrors;
  };

  const validateProduct = () =>
    !nameEn?.trim() ||
    !descriptionEn?.trim() ||
    !selectedBrand?.value ||
    !benefitsEn?.trim() ||
    !featuresEn?.trim() ||
    !howToEn?.trim() ||
    !selectedCat?.length;

  // ─── Save (create) ────────────────────────────────────────────────────────
  const handleSaveProduct = () => {
    const hasVariantErrors = validateVariants();
    const hasProductErrors = validateProduct();

    if (hasVariantErrors || hasProductErrors) {
      setGeneralMessage(true);
      setErrorMessage(hasProductErrors);
      setSubmitForm(true);
      return;
    }

    setGeneralMessage(false);
    setErrorMessage(false);

    props.onSave({
      name_en: nameEn,
      video: video || "",
      country_of_origin: country_of_origin || "",
      lead_days: lead_days || "",
      name_ar: nameAr?.trim() ? nameAr : nameEn,
      description_en: descriptionEn,
      description_ar:
        descriptionAr?.trim() && descriptionAr !== "<p><br></p>"
          ? descriptionAr
          : descriptionEn,
      benefits_en: benefitsEn,
      benefits_ar:
        benefitsAr?.trim() && benefitsAr !== "<p><br></p>"
          ? benefitsAr
          : benefitsEn,
      features_en: featuresEn,
      features_ar:
        featuresAr?.trim() && featuresAr !== "<p><br></p>"
          ? featuresAr
          : featuresEn,
      how_to_use_en: howToEn,
      how_to_use_ar:
        howToAr?.trim() && howToAr !== "<p><br></p>" ? howToAr : howToEn,
      product_categories_attributes: selectedCat.map((cat) => ({
        category_id: cat.value,
      })),
      product_keywords_attributes: buildKeywords(),
      brand_id: selectedBrand.value,
      tool: isTool,
      product_type: isWholesale ? "wholesale" : "retail",
      unit: selectedUnit.value,
      is_inquiry: isInquiry,
      is_bulk_order: isBulkOrder,
      pickup_allowed: pickupAllowed,
      product_related_products_attributes: !isTool ? mergeArrays() : [],
      product_related_services_attributes: !isTool
        ? convertToServiceList()
        : [],
      shipment_rule_id: selectedShipmentRule?.value,
    });

    setSubmitForm(true);
  };

  // ─── Update ───────────────────────────────────────────────────────────────
  const handleUpdateProduct = () => {
    const hasVariantErrors = validateVariants();
    const hasProductErrors = validateProduct();

    if (hasVariantErrors || hasProductErrors) {
      setGeneralMessage(true);
      setErrorMessage(hasProductErrors);
      setSubmitForm(true);
      return;
    }

    setGeneralMessage(false);
    setErrorMessage(false);

    props.onUpdate({
      id: props.product.id,
      name_en: nameEn,
      video: video || "",
      country_of_origin: country_of_origin || "",
      lead_days: lead_days || "",
      unit: selectedUnit.value,
      name_ar: nameAr?.trim() ? nameAr : nameEn,
      description_en: descriptionEn,
      description_ar:
        descriptionAr?.trim() && descriptionAr !== "<p><br></p>"
          ? descriptionAr
          : descriptionEn,
      benefits_en: benefitsEn,
      benefits_ar:
        benefitsAr?.trim() && benefitsAr !== "<p><br></p>"
          ? benefitsAr
          : benefitsEn,
      features_en: featuresEn,
      features_ar:
        featuresAr?.trim() && featuresAr !== "<p><br></p>"
          ? featuresAr
          : featuresEn,
      how_to_use_en: howToEn,
      how_to_use_ar:
        howToAr?.trim() && howToAr !== "<p><br></p>" ? howToAr : howToEn,
      product_categories_attributes: selectedCat.map((cat) => ({
        category_id: cat.value,
      })),
      product_keywords_attributes: buildKeywords(),
      brand_id: selectedBrand.value,
      tool: isTool,
      is_inquiry: isInquiry,
      is_bulk_order: isBulkOrder,
      pickup_allowed: pickupAllowed,
      product_related_products_attributes: !isTool ? mergeArrays() : [],
      product_related_services_attributes: !isTool
        ? convertToServiceList()
        : [],
      shipment_rule_id: selectedShipmentRule?.value,
    });

    setSubmitForm(true);
  };

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div className="product-card">
      <h3 className="title">Product Information</h3>

      <div className="grid">
        {/* First Column */}
        <div className="col">
          <div className="row">
            <div className="input half">
              <label>Name*</label>
              <input
                placeholder="Enter name"
                type="text"
                value={nameEn}
                disabled={show}
                onChange={(e) => setNameEn(e.target.value)}
              />
              {errorMessage && !nameEn?.trim() && (
                <div className="error">Required</div>
              )}
            </div>

            <div className="input half">
              <label>اسم</label>
              <input
                placeholder="أدخل الاسم"
                type="text"
                value={nameAr}
                name="name_ar"
                disabled={show}
                onChange={(e) => setNameAr(e.target.value)}
              />
            </div>
          </div>

          <div className="row">
            <div className="input half">
              <label>Description*</label>
              <CKEditor
                editor={ClassicEditor}
                data={descriptionEn || ""}
                disabled={show}
                onChange={(event, editor) => setDescriptionEn(editor.getData())}
              />
              {errorMessage && !descriptionEn?.trim() && (
                <div className="error">Required</div>
              )}
            </div>

            <div className="input half">
              <label>وصف</label>
              <CKEditor
                editor={ClassicEditor}
                data={descriptionAr || ""}
                disabled={show}
                onChange={(event, editor) => setDescriptionAr(editor.getData())}
              />
            </div>
          </div>

          <div className="row">
            <div className="input half">
              <label>Benefits*</label>
              <CKEditor
                className={getClass(errorMessage && !benefitsEn?.trim())}
                editor={ClassicEditor}
                data={benefitsEn || ""}
                disabled={show}
                onChange={(event, editor) => setBenefitsEn(editor.getData())}
              />
              {errorMessage && !benefitsEn?.trim() && (
                <div className="error">Required</div>
              )}
            </div>
            <div className="input half">
              <label>فوائد</label>
              <CKEditor
                editor={ClassicEditor}
                data={benefitsAr || ""}
                disabled={show}
                onChange={(event, editor) => setBenefitsAr(editor.getData())}
              />
            </div>
          </div>

          <div className="row">
            <div className="input half">
              <label>Features*</label>
              <CKEditor
                className={getClass(errorMessage && !featuresEn?.trim())}
                editor={ClassicEditor}
                data={featuresEn || ""}
                disabled={show}
                onChange={(event, editor) => setFeaturesEn(editor.getData())}
              />
              {errorMessage && !featuresEn?.trim() && (
                <div className="error">Required</div>
              )}
            </div>
            <div className="input half">
              <label>سمات</label>
              <CKEditor
                editor={ClassicEditor}
                data={featuresAr || ""}
                disabled={show}
                onChange={(event, editor) => setFeaturesAr(editor.getData())}
              />
            </div>
          </div>

          <div className="row">
            <div className="input half">
              <label>How To Use*</label>
              <CKEditor
                className={getClass(errorMessage && !howToEn?.trim())}
                editor={ClassicEditor}
                data={howToEn || ""}
                disabled={show}
                onChange={(event, editor) => setHowToEn(editor.getData())}
              />
              {errorMessage && !howToEn?.trim() && (
                <div className="error">Required</div>
              )}
            </div>
            <div className="input half">
              <label>كيفية الاستخدام</label>
              <CKEditor
                editor={ClassicEditor}
                data={howToAr || ""}
                disabled={show}
                onChange={(event, editor) => setHowToAr(editor.getData())}
              />
            </div>
          </div>

          <div className="row">
            <div className="input half">
              <label>
                Video*&nbsp;
                <OverlayTrigger
                  placement="right-start"
                  overlay={
                    <Tooltip
                      id="tooltip-video"
                      style={{
                        maxWidth: "400px",
                        width: "400px",
                        padding: "12px",
                        fontSize: "13px",
                        lineHeight: "1.5",
                      }}
                    >
                      Paste the full YouTube embed iframe code here.
                    </Tooltip>
                  }
                >
                  <span>
                    <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                  </span>
                </OverlayTrigger>
              </label>
              <input
                placeholder="Enter youtube video link"
                type="text"
                value={video}
                disabled={show}
                onChange={(e) => setVideo(e.target.value)}
              />
            </div>

            {!isTool && (
              <div className="input half">
                <label>
                  Related Products&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-related-products"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                          lineHeight: "1.5",
                        }}
                      >
                        Choose other products that complement or go together
                        with this one.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
                <RSelect
                  isMulti
                  isDisabled={show}
                  value={selectedProduct}
                  onChange={setSelectedProduct}
                  options={relatedProducts}
                  onInputChange={handleRelatedProductsInputChange}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  isLoading={loading}
                />
              </div>
            )}
          </div>

          <div className="row">
            {!isTool && (
              <div className="input half">
                <label>
                  Related Services&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-related-services"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                          lineHeight: "1.5",
                        }}
                      >
                        Select services (like installation or maintenance) that
                        are related to this product.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
                <RSelect
                  isMulti
                  isDisabled={show}
                  value={selectedService}
                  onChange={setSelectedService}
                  options={relatedServices}
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </div>
            )}

            {!isTool && (
              <div className="input half">
                <label>
                  Related Tools&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-related-tools"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                          lineHeight: "1.5",
                        }}
                      >
                        Link this product to tools commonly used with it.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
                <RSelect
                  isMulti
                  isDisabled={show}
                  value={selectedTool}
                  onChange={setSelectedTool}
                  options={relatedTools}
                  onInputChange={handleRelatedToolsInputChange}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  isLoading={loading}
                />
              </div>
            )}
          </div>
        </div>

        {/* Second Column */}
        <div className="col">
          <div className="input">
            <label>
              Category*&nbsp;
              <OverlayTrigger
                placement="right-start"
                overlay={
                  <Tooltip
                    id="tooltip-category"
                    style={{
                      maxWidth: "400px",
                      width: "400px",
                      padding: "12px",
                      fontSize: "13px",
                      lineHeight: "1.5",
                    }}
                  >
                    Choose the most relevant category so customers can easily
                    find this product.
                  </Tooltip>
                }
              >
                <span>
                  <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                </span>
              </OverlayTrigger>
            </label>
            <RSelect
              isMulti
              isDisabled={show}
              name="category_id"
              value={selectedCat}
              onChange={setSelectedCat}
              options={categoriesList}
              className={`category-select ${getClass(errorMessage && !selectedCat?.length)}`}
              classNamePrefix="control"
            />
            {errorMessage && !selectedCat?.length && (
              <div className="error">Required</div>
            )}
          </div>

          <div className="input">
            <label>
              Brand*&nbsp;
              <OverlayTrigger
                placement="right-start"
                overlay={
                  <Tooltip
                    id="tooltip-brand"
                    style={{
                      maxWidth: "400px",
                      width: "400px",
                      padding: "12px",
                      fontSize: "13px",
                      lineHeight: "1.5",
                    }}
                  >
                    Select the correct brand name. If the brand is missing,
                    contact support to add it.
                  </Tooltip>
                }
              >
                <span>
                  <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                </span>
              </OverlayTrigger>
            </label>
            <RSelect
              isDisabled={show}
              name="brand_id"
              value={selectedBrand}
              onChange={setSelectedBrand}
              options={brandsList}
              className={`category-select ${getClass(errorMessage && !selectedBrand?.value)}`}
              classNamePrefix="control"
            />
            {errorMessage && !selectedBrand?.value && (
              <div className="error">Required</div>
            )}
          </div>

          <div className="input">
            <label>
              Country of origin&nbsp;
              <OverlayTrigger
                placement="right-start"
                overlay={
                  <Tooltip
                    id="tooltip-country"
                    style={{
                      maxWidth: "400px",
                      width: "400px",
                      padding: "12px",
                      fontSize: "13px",
                      lineHeight: "1.5",
                    }}
                  >
                    Specify where the product was manufactured or assembled.
                  </Tooltip>
                }
              >
                <span>
                  <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                </span>
              </OverlayTrigger>
            </label>
            <input
              placeholder="Enter country of origin"
              type="text"
              value={country_of_origin}
              disabled={show}
              onChange={(e) => setCountryOfOrigin(e.target.value)}
            />
          </div>

          <div className="input">
            <label>Measuring unit</label>
            <RSelect
              isDisabled={show}
              value={selectedUnit}
              onChange={setSelectedUnit}
              options={productUnitOptions}
              className="category-select"
              classNamePrefix="control"
            />
          </div>

          <div className="input">
            <label>
              Shipment Rule*&nbsp;
              <OverlayTrigger
                placement="right-start"
                overlay={
                  <Tooltip
                    id="tooltip-shipment"
                    style={{
                      maxWidth: "400px",
                      width: "400px",
                      padding: "12px",
                      fontSize: "13px",
                      lineHeight: "1.5",
                      textAlign: "left",
                    }}
                  >
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Shipping Included in Price:</strong>
                      <div>
                        No extra shipping cost — fee is already in the product
                        price.
                      </div>
                    </div>
                    <hr style={{ margin: "6px 0" }} />
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Weight-Based Shipping:</strong>
                      <div>
                        Orders under 20 tons = AED 500. Over 20 tons = free
                        shipping.
                      </div>
                    </div>
                    <hr style={{ margin: "6px 0" }} />
                    <div style={{ marginBottom: "8px" }}>
                      <strong>Free Shipping Over 99:</strong>
                      <div>
                        Orders above AED 99 = free. Below 99: Dubai = AED 15,
                        Other Emirates = AED 20.
                      </div>
                    </div>
                    <hr style={{ margin: "6px 0" }} />
                    <div>
                      <strong>Free Shipping Over 3000 (Tiered Charges):</strong>
                      <div>
                        Orders above AED 3000 = free. Below 3000: Dubai = AED
                        250, Sharjah/Ajman = AED 180, others have specific
                        charges.
                      </div>
                    </div>
                  </Tooltip>
                }
              >
                <span>
                  <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                </span>
              </OverlayTrigger>
            </label>
            <RSelect
              isDisabled={show}
              name="shipment_rule_id"
              value={selectedShipmentRule}
              onChange={setSelectedShipmentRule}
              options={shipmentRulesList}
              className="category-select"
              classNamePrefix="control"
            />
          </div>

          <div className="input">
            <label>
              Lead Days&nbsp;
              <OverlayTrigger
                placement="right-start"
                overlay={
                  <Tooltip
                    id="tooltip-lead-days"
                    style={{
                      maxWidth: "400px",
                      width: "400px",
                      padding: "12px",
                      fontSize: "13px",
                      lineHeight: "1.5",
                    }}
                  >
                    Enter the number of days required before the product is
                    ready to ship.
                  </Tooltip>
                }
              >
                <span>
                  <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                </span>
              </OverlayTrigger>
            </label>
            <input
              placeholder="Enter lead days"
              type="number"
              value={lead_days}
              disabled={show}
              onChange={(e) => setLeadDays(e.target.value)}
            />
          </div>

          <div className="input">
            <label>
              Keywords&nbsp;
              <OverlayTrigger
                placement="right-start"
                overlay={
                  <Tooltip
                    id="tooltip-keywords"
                    style={{
                      maxWidth: "400px",
                      width: "400px",
                      padding: "12px",
                      fontSize: "13px",
                      lineHeight: "1.5",
                    }}
                  >
                    Add keywords customers might search for. Press Enter after
                    each keyword.
                  </Tooltip>
                }
              >
                <span>
                  <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                </span>
              </OverlayTrigger>
            </label>
            <ReactTags
              tags={tags}
              suggestions={suggestions}
              delimiters={delimiters}
              handleDelete={handleDelete}
              handleAddition={handleAddition}
              handleDrag={handleDrag}
              handleTagClick={handleTagClick}
              inputFieldPosition="bottom"
              autocomplete
              autofocus={false}
              style={{ width: "100%" }}
            />
          </div>

          <div className="input">
            <FormControlLabel
              control={
                <Switch
                  onChange={() => setIsInquiry(!isInquiry)}
                  checked={isInquiry}
                  disabled={show}
                />
              }
              label={
                <label>
                  Is this an inquiry product?&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-inquiry"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                        }}
                      >
                        Mark 'Yes' if customers can only send inquiries about
                        this product instead of buying directly.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
              }
            />
          </div>

          <div className="input">
            <FormControlLabel
              control={
                <Switch
                  onChange={() => setIsTool(!isTool)}
                  checked={isTool}
                  disabled={show}
                  color="primary"
                />
              }
              label={
                <label>
                  It is a Tool&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-tool"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                        }}
                      >
                        Select 'Yes' if this product is a tool.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
              }
            />
          </div>

          <div className="input">
            <FormControlLabel
              control={
                <Switch
                  onChange={() => setIsWholesale(!isWholesale)}
                  checked={isWholesale}
                  disabled={show}
                />
              }
              label={
                <label>
                  Is wholesale product?&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-wholesale"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                        }}
                      >
                        Select 'Yes' if this product is available for wholesale
                        buyers at wholesale pricing.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
              }
            />
          </div>

          <div className="input">
            <FormControlLabel
              control={
                <Switch
                  onChange={() => setIsBulkOrder(!isBulkOrder)}
                  checked={isBulkOrder}
                  disabled={show}
                />
              }
              label={
                <label>
                  Is bulk order?&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-bulk"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                        }}
                      >
                        Select 'Yes' if this product is sold in large quantities
                        (e.g., cartons, pallets) instead of single pieces.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
              }
            />
          </div>

          <div className="input">
            <FormControlLabel
              control={
                <Switch
                  onChange={() => setPickupAllowed(!pickupAllowed)}
                  checked={pickupAllowed}
                  disabled={show}
                />
              }
              label={
                <label>
                  Allow this product for pickup order?&nbsp;
                  <OverlayTrigger
                    placement="right-start"
                    overlay={
                      <Tooltip
                        id="tooltip-pickup"
                        style={{
                          maxWidth: "400px",
                          width: "400px",
                          padding: "12px",
                          fontSize: "13px",
                        }}
                      >
                        Enable if buyers can pick up the product directly
                        instead of requesting shipment.
                      </Tooltip>
                    }
                  >
                    <span>
                      <FaRegQuestionCircle style={{ cursor: "pointer" }} />
                    </span>
                  </OverlayTrigger>
                </label>
              }
            />
          </div>
        </div>
      </div>

      {/* Variants */}
      {props.variants.map(
        (variant, index) =>
          !variant._destroy && (
            <VariantCard
              selected={selectedVar}
              onUpdateVar={(id) => setSelectedVar(id)}
              variant={variant}
              variants={props.variants}
              index={index + 1}
              onUpdate={(id) => {
                typeof id === "string"
                  ? props.set_variants(
                      props.variants.filter((ele) => ele.id !== id),
                    )
                  : props.set_variants(
                      props.variants.map((ele) =>
                        ele.id === id ? { ...ele, _destroy: true } : ele,
                      ),
                    );
              }}
              product_type={isWholesale ? "wholesale" : "retail"}
              key={variant.id}
            />
          ),
      )}

      {/* Add Variant */}
      {state !== "view" && props.store?.can_manage_product && (
        <div className="d-flex justify-content-end mb-2 mt-4">
          <div
            onClick={() => {
              props.set_variants([
                ...props.variants,
                {
                  id: Math.random() + "var",
                  name_en: "",
                  name_ar: "",
                  description_en: "",
                  description_ar: "",
                  discounted_price: undefined,
                  quantity: undefined,
                  variation: "",
                  price: undefined,
                  sku: undefined,
                  upc_code: undefined,
                  weight: undefined,
                  featured_image: "",
                  featured_image_resized: [],
                  images: [],
                  benefits_en: "",
                  benefits_ar: "",
                  features_en: "",
                  features_ar: "",
                  how_to_use_en: "",
                  how_to_use_ar: "",
                },
              ]);
            }}
            className="pointer add-variant-button"
          >
            Add Variant +
          </div>
        </div>
      )}

      {/* General error */}
      {generalMessage && <div className="error">Please fill empty fields</div>}

      {/* Action Buttons */}
      {id === "create" ? (
        <Box display="flex" gridGap={16}>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSaveProduct}
            size="large"
            startIcon={
              props.loading ? (
                <ClipLoader color="#000" loading size={25} />
              ) : (
                <MdOutlineSave size="1.5rem" />
              )
            }
          >
            Save Product
          </Button>
          <Button
            variant="outlined"
            onClick={() => props.onClose()}
            size="large"
          >
            Cancel
          </Button>
        </Box>
      ) : state === "edit" ? (
        <Box display="flex" gridGap={16}>
          <div className="w-30 button-cont">
            {props.loading ? (
              <ClipLoader color="#000" loading size={25} />
            ) : (
              props.store?.can_manage_product && (
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleUpdateProduct}
                  size="large"
                >
                  Update
                </Button>
              )
            )}
          </div>
          <Link
            to={{
              pathname: `/vendor/product/${id}/view`,
              state: { id, name: "view" },
            }}
          >
            <Button variant="outlined" size="large">
              Cancel
            </Button>
          </Link>
        </Box>
      ) : (
        <Box display="flex" marginTop={2} gridGap={16}>
          {props.store?.can_manage_product && (
            <Link
              to={{
                pathname: `/vendor/product/${props.product.id}/edit`,
                state: { id: props.product.id },
              }}
            >
              <Button color="primary" variant="contained" size="large">
                Edit
              </Button>
            </Link>
          )}
          <Link to={{ pathname: `/vendor/product-catalog` }}>
            <Button variant="outlined" size="large">
              Cancel
            </Button>
          </Link>
        </Box>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  categories: state.category.categories,
  brands: state.brand.brands,
  productDetails: state.product.productDetails,
  variants: state.product.variants,
  store: state.vendorStore.vendorStore,
});

const mapDispatchTopProps = {
  set_categories,
  set_brands,
  set_variants,
};

export default connect(mapStateToProps, mapDispatchTopProps)(ProductCard);
